import * as types from '../mutation-types';
import HubAPI from '../../api/hub';
import AgentAPI from '../../api/agents';

const defaultAgentFlags = { isFetching: false, fetchFailed: false };

export const state = {
  projects: [],
  workspaces: [],
  hubUserData: {},
  hubUserDataFlags: {},
  uiFlags: {
    isFetchingProjects: false,
    isFetchingWorkspaces: false,
    fetchProjectsFailed: false,
    fetchWorkspacesFailed: false,
  },
};

export const getters = {
  getProjects: $state => $state.projects,
  getWorkspaces: $state => $state.workspaces,
  getHubUserData: $state => agentId => $state.hubUserData[agentId] || {},
  getHubUserDataFlags: $state => agentId =>
    $state.hubUserDataFlags[agentId] || { ...defaultAgentFlags },
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetchProjects: async ({ commit }) => {
    commit(types.default.SET_HUB_PROJECTS_FETCHING_STATUS, true);
    commit(types.default.SET_HUB_PROJECTS_FETCH_FAILED, false);
    try {
      const { data } = await HubAPI.getClaudiaProjects();
      commit(types.default.SET_HUB_PROJECTS, data);
    } catch (error) {
      commit(types.default.SET_HUB_PROJECTS_FETCH_FAILED, true);
    } finally {
      commit(types.default.SET_HUB_PROJECTS_FETCHING_STATUS, false);
    }
  },
  fetchWorkspaces: async ({ commit }) => {
    commit(types.default.SET_HUB_WORKSPACES_FETCHING_STATUS, true);
    commit(types.default.SET_HUB_WORKSPACES_FETCH_FAILED, false);
    try {
      const { data } = await HubAPI.getEddieWorkspaces();
      commit(types.default.SET_HUB_WORKSPACES, data);
    } catch (error) {
      commit(types.default.SET_HUB_WORKSPACES_FETCH_FAILED, true);
    } finally {
      commit(types.default.SET_HUB_WORKSPACES_FETCHING_STATUS, false);
    }
  },
  fetchHubUserData: async ({ commit }, agentId) => {
    commit(types.default.SET_HUB_USER_DATA_FETCHING_STATUS, {
      agentId,
      status: true,
    });
    commit(types.default.SET_HUB_USER_DATA_FETCH_FAILED, {
      agentId,
      status: false,
    });
    try {
      const { data } = await AgentAPI.hubUserData(agentId);
      commit(types.default.SET_HUB_USER_DATA, { agentId, data });
    } catch (error) {
      commit(types.default.SET_HUB_USER_DATA_FETCH_FAILED, {
        agentId,
        status: true,
      });
    } finally {
      commit(types.default.SET_HUB_USER_DATA_FETCHING_STATUS, {
        agentId,
        status: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_HUB_PROJECTS_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingProjects = status;
  },
  [types.default.SET_HUB_WORKSPACES_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingWorkspaces = status;
  },
  [types.default.SET_HUB_USER_DATA_FETCHING_STATUS](
    $state,
    { agentId, status }
  ) {
    const current = $state.hubUserDataFlags[agentId] || {
      ...defaultAgentFlags,
    };
    $state.hubUserDataFlags = {
      ...$state.hubUserDataFlags,
      [agentId]: { ...current, isFetching: status },
    };
  },
  [types.default.SET_HUB_PROJECTS]($state, data) {
    $state.projects = data;
  },
  [types.default.SET_HUB_WORKSPACES]($state, data) {
    $state.workspaces = data;
  },
  [types.default.SET_HUB_USER_DATA]($state, { agentId, data }) {
    $state.hubUserData = { ...$state.hubUserData, [agentId]: data };
  },
  [types.default.SET_HUB_PROJECTS_FETCH_FAILED]($state, status) {
    $state.uiFlags.fetchProjectsFailed = status;
  },
  [types.default.SET_HUB_WORKSPACES_FETCH_FAILED]($state, status) {
    $state.uiFlags.fetchWorkspacesFailed = status;
  },
  [types.default.SET_HUB_USER_DATA_FETCH_FAILED]($state, { agentId, status }) {
    const current = $state.hubUserDataFlags[agentId] || {
      ...defaultAgentFlags,
    };
    $state.hubUserDataFlags = {
      ...$state.hubUserDataFlags,
      [agentId]: { ...current, fetchFailed: status },
    };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
